<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("Renunciation") }}</div>
      </div>
      <div class="d-flex">
        <!-- <b-button variant="default" to="profile" class="btn-blue">{{ $t('Profile') }}</b-button> -->
        <b-button
          v-if="$can('create', 'Renunciation')"
          variant="default"
          to="add-renunciation"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >

        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
            <strong>{{ viewingRange }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class>
          <!-- <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              href="#"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown> -->
        </div>
        <!-- <div class="viewing-status">
          Viewing
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
      </div>
    </div>

    <table class="list-view-table">
      <thead>
        <tr>
          <th class>
            <img
              v-if="this.columnName != 'first_name'"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('first_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("name") }}
          </th>
          <th class>
            <img
              v-if="this.columnName != 'up_employee_code'"
              @click="onSortValue('up_employee_code', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('up_employee_code', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('up_employee_code', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("employee") }} ID
          </th>
          <th class>
            <img
              v-if="this.columnName != 'up_doj'"
              @click="onSortValue('up_doj', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('up_doj', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('up_doj', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("doj") }}
          </th>
          <th class>
            <img
              v-if="this.columnName != 'up_dol'"
              @click="onSortValue('up_dol', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('up_dol', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('up_dol', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $t("dol") }}
          </th>
          <th class="">&emsp;&emsp;&emsp;{{ $t("view") }}</th>
        </tr>
      </thead>
      <tbody v-if="Renunciation.length > 0">
        <tr v-for="(item, key) in Renunciation" :key="key">
          <td class>
            {{ item.first_name }} {{ item.middle_name }} {{ item.last_name }}
          </td>
          <td class>{{ item.up_employee_code }}</td>
          <td class>{{ item.up_doj | dateparse }}</td>
          <td class>{{ item.up_dol | dateparse }}</td>
          <td>
            <div class="my-2">
              <b-button
                variant="default"
                @click="goToRoute('/user-management/view-user', item)"
                class="btn-blue"
                >{{ $t("profile") }}</b-button
              >
            </div>
          </td>
        </tr>
        <!-- <tr v-if="Renunciation && Renunciation.length == 0">
          <td class="text-center" colspan="5">No Records Found</td>
        </tr> -->
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="5">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
export default {
  components: {
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      Renunciation: [],
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getviewingnumber();
    this.ListRenunciation();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRolesList();
      } else {
        this.currentPage = event;
        this.getRolesList();
      }
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.ListRenunciation();
    },

    ListRenunciation() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        columnName: this.columnName,
        orderBy: this.orderby,
      };

      UserService.GetRenunciation(payload)
        .then((response) => {
          const { data } = response;
          if (data.Status) {
            this.Renunciation = data.Records;
            console.log("this.Renunciation :", this.Renunciation);
            if (data.totalRows >= 10) {
              this.rows = data.totalRows;
            } else {
              this.rows = data.totalRows;
              this.selectedvalue = data.totalRows;
            }
            // console.log("this.Renunciation :", this.Renunciation);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          this.$toasted.show(error);
          console.log("show error :", error);
        });
      // moment(
      //             new Date(this.SchedulePriceObject.p_start_date_time)
      //           ).format("YYYY-MM-DD HH:mm:ss")
    },

    goToRoute: function (path, item) {
      // console.log("item :", item);
      const { user_id } = item;
      // console.log("user_id :", item);
      this.$store.dispatch("setUserDoL", item.up_dol);
      this.$store.dispatch("setUserRol", item.up_reason_for_leaving);
      this.$store.dispatch("setUserisActive", item.is_active);
      this.$router.push({
        path: path,
        query: {
          uid: user_id,
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/RenunciationComponents/renunciation.vue